import { Outlet, NavLink, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const NAV = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/kurslar", label: "Kurslar" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/galeri", label: "Galeri" },
  { to: "/sss", label: "SSS" },
  { to: "/iletisim", label: "İletişim" },
];

export default function PublicLayout() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white text-neutral-900">
      <header
        className={`fixed top-0 left-0 right-0 z-40 ${
          scrolled ? "glass-header" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" data-testid="header-logo" className="flex items-center gap-2 font-display text-lg font-medium tracking-tight">
            <span className="w-2 h-2 rounded-full bg-[color:var(--ek-accent)]" />
            <span>EhliyetKurs</span>
          </Link>
          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors ${
                    isActive ? "text-neutral-900" : "text-neutral-500 hover:text-neutral-900"
                  }`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-3">
            <a href="tel:+908501234567" data-testid="header-phone" className="text-sm text-neutral-600 hover:text-neutral-900 flex items-center gap-1.5">
              <Phone size={14} /> 0850 123 45 67
            </a>
            <Link to="/basvuru" data-testid="header-apply-btn" className="btn-accent text-sm !py-2.5 !px-5">
              Hemen Başvur
            </Link>
          </div>
          <button
            className="lg:hidden p-2 -mr-2"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
        {open && (
          <div className="lg:hidden glass-header border-t border-black/5">
            <div className="px-6 py-6 flex flex-col gap-4">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  data-testid={`mobile-nav-${n.to.replace("/", "") || "home"}`}
                  className={({ isActive }) => `text-base font-medium ${isActive ? "text-neutral-900" : "text-neutral-500"}`}
                  end={n.to === "/"}
                >
                  {n.label}
                </NavLink>
              ))}
              <Link to="/basvuru" data-testid="mobile-apply-btn" className="btn-accent justify-center mt-2">
                Hemen Başvur
              </Link>
            </div>
          </div>
        )}
      </header>

      <main className="flex-1 pt-16">
        <Outlet />
      </main>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

function Footer() {
  return (
    <footer className="bg-[color:var(--ek-black)] text-neutral-300 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-[color:var(--ek-accent)]" />
            <span className="font-display text-xl text-white font-medium">EhliyetKurs</span>
          </div>
          <p className="text-sm text-neutral-400 max-w-md leading-relaxed">
            25 yıllık tecrübeyle sürücü belgesi, MYK sertifika ve iş makinaları operatörlük eğitimlerinde Türkiye'nin öncüsü.
          </p>
        </div>
        <div>
          <div className="overline text-neutral-500 mb-4">Kurslar</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-white" to="/kurslar">Ehliyet Sınıfları</Link></li>
            <li><Link className="hover:text-white" to="/kurslar">MYK Kursları</Link></li>
            <li><Link className="hover:text-white" to="/kurslar">İş Makinaları</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-neutral-500 mb-4">İletişim</div>
          <ul className="space-y-2 text-sm text-neutral-400">
            <li>0850 123 45 67</li>
            <li>info@ehliyetkursu.com</li>
            <li>Örnek Mah. Kurs Cad. No:1</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} EhliyetKurs. Tüm hakları saklıdır.</div>
          <div className="flex gap-4">
            <span>KVKK</span>
            <span>Çerez Politikası</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
